<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2025-01-20</p>

    <div class="content">
      <!-- 第一段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>
      <!-- 第二段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>
      <!-- 图片部分 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url" >
        </div>
      </div>
     
      
      

      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>
     </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'niandupandian');
  return newsItem || {};
});

</script>

<style scoped lang="scss">
/* 页面特定样式可以放在这里 */
.page-container{
overflow: auto; 
}
</style> 